<div
  class="root"
  [id]="getMessageContentType(message()) + '-' + message().id"
  skyTranslationGuard="skypro-communication-message"
  data-test="сообщение обсуждения"
>
  <div class="avatar">
    <vim-core-user-avatar
      [user]="message().author.user"
      [avatarUrl]="message().author.avatarUrl"
      [size]="40"
    ></vim-core-user-avatar>
  </div>

  <div class="container">
    <div class="header">
      <div class="author-name" data-test="автор">
        {{ message().author.user.name }}
        @if (message().isEdited) {
          <span class="edited-label" data-test="метка отредактированного сообщения">
            (изменено)
          </span>
        }

        @if (isAiGenerated()) {
          <span class="ai-generated-badge">Ответил ИИ</span>
        }
      </div>

      <div class="actions-group">
        <ds-icon-more
          class="more"
          size="m"
          [matMenuTriggerFor]="menu"
          data-test="кнопка меню действий с сообщением"
        ></ds-icon-more>

        <mat-menu #menu="matMenu">
          @if (!message().isDeleted && deliveryStatus() !== 'pending') {
            @if (canEdit()) {
              <button
                mat-menu-item
                (click)="editMessage()"
                data-test="кнопка редактирования сообщения"
              >
                Редактировать
              </button>
            }
            @if (canDelete()) {
              <button
                class="delete-button"
                mat-menu-item
                (click)="deleteMessage()"
                data-test="кнопка удалить сообщение"
              >
                Удалить
              </button>
            }
          }
          @if (isAiGenerated()) {
            <button
              mat-menu-item
              (click)="doCreateAiMessageReport()"
              data-test="кнопка отправить кринж"
            >
              🤡 Кринж
            </button>
          }
          @if (showDebugDraft) {
            <a mat-menu-item href="{{ getDebugLink(message().id) }}" target="_blank">
              Дебажить ответ ИИ
            </a>
          }
          <span mat-menu-item disabled>ID: {{ message().id }}</span>
        </mat-menu>
      </div>
    </div>
    <div class="main" data-test="тред обсуждения">
      <div class="message">
        @if (!message().isDeleted) {
          <quill-view-html
            #messageBodyRef
            data-test="текст сообщения обсуждения"
            class="message-body"
            [content]="getFlatMessageBody(message().body)"
            [sanitize]="true"
          ></quill-view-html>

          <div class="attachment-grid">
            @for (
              attachment of message().attachments;
              track trackByAttachment($index, attachment)
            ) {
              <skypro-message-attachment-preview
                class="attachment-item"
                [url]="attachment.url"
                [title]="attachment.title"
              ></skypro-message-attachment-preview>
            }
          </div>
        } @else {
          <p class="deleted-message" data-test="текст удаленного сообщения">Сообщение удалено</p>
        }
      </div>
      @if (deliveryStatus() === 'failed') {
        <div class="sending-failed" [dsTooltip]="deliveryError()">
          <ds-icon-attention size="s"></ds-icon-attention>
          <span>Не отправлено</span>
        </div>
      } @else if (deliveryStatus() !== 'pending') {
        <div class="date">
          @if (isToday(message().createdAt)) {
            {{ message().createdAt | date: 'HH:mm' }}
          } @else {
            {{ message().createdAt | date: 'dd.MM.yy HH:mm' }}
          }
        </div>
      }
    </div>
  </div>
</div>
